import { useEffect, useState } from 'react';

export default function useMax({ data, property }: { data: any; property: string }) {
	const [max, setMax] = useState<number>(undefined);

	useEffect(() => {
		if (!property) {
			setMax(1);
		}
		let rtn = undefined;
		data?.features?.forEach((feature: any) => {
			const value = feature.properties[property];
			if (rtn === undefined) rtn = value;
			else if (value > rtn) rtn = value;
		});
		if (isNaN(rtn) || rtn <= 0) rtn = 1;
		setMax(rtn);
	}, [data, property]);

	return [{ max }, { setMax }];
}
